// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Actif',
    active_switch_description: 'En désactivant la propriété Active de l\'utilisateur, vous faites deux choses : libérer une licence pour un autre utilisateur et rendre l\'utilisateur inactif invisible partout dans le système, à l\'exception de la page Utilisateurs.',
    apply: 'Appliquer',
    assign: 'Ajouter',
    assigned_activities_menu_title: 'Activités assignées',
    can_login: 'Connexion possible',
    can_login_switch_description: 'En désactivant Connexion possible, vous refusez uniquement l\'accès de l\'utilisateur au système. L\'utilisateur peut toujours être un membre du projet ou une personne assignée. Cette action libérera également une licence si vous en avez besoin.',
    cancel: 'Annuler',
    CanDenyLogin_User_DenyLoginYourself: 'Vous ne pouvez pas désactiver la Connexion possible pour vous-même.',
    CanDenyLogin_User_LastAdministrator: 'Vous ne pouvez pas désactiver la Connexion possible pour un utilisateur qui est le seul administrateur du système.',
    CanDisable_User_DisableYourself: 'Vous ne pouvez pas désactiver Actif pour vous-même.',
    CanDisable_User_LastAdministrator: 'Vous ne pouvez pas désactiver Actif pour un utilisateur qui est le seul administrateur du système.',
    cant_delete_user: 'L\'utilisateur n\'a pas pu être supprimé',
    cant_login: 'Connexion impossible',
    change_password: 'Modifier le mot de passe',
    close: 'Fermer',
    convert_title: 'Convertir',
    convert_to_regular: 'Convertir en utilisateur normal',
    convert_to_regular_title: 'Convertir {0} en utilisateur normal avec le rôle :',
    deactivate: 'Modifier le statut',
    deactivateTitle: 'Modifier le statut de l\'utilisateur sur Inactif',
    delete: 'Supprimer',
    delete_confirm: 'Supprimer cet utilisateur ?',
    delete_skill_title: 'Supprimer la compétence',
    delete_team_title: 'Supprimer l\'équipe',
    DeleteRateBtnTitle: 'Supprimer définitivement',
    Disable_Permission_Message: 'Vous êtes sur le point de désactiver une autorisation dans votre rôle qui vous permet de modifier vos propres autorisations et celles des autres utilisateurs.',
    Disable_Permission_Title: 'Vous ne pourrez plus modifier les autorisations des utilisateurs.',
    DisplayName_customerId: 'Client',
    DisplayName_email: 'E-mail',
    DisplayName_hourlyRate: 'Taux horaire de facturation',
    DisplayName_login: 'Connexion',
    email: 'E-mail',
    exclude: 'Exclure',
    filterbystatus_Active: 'Actifs uniquement',
    filterbystatus_All: 'Actifs et inactifs',
    filterbystatus_CannotLogin: 'Connexion impossible uniquement',
    filterbystatus_Inactive: 'Inactifs uniquement',
    generate: 'Générer',
    guest_portal_title: 'Portail des invités.',
    guests_interaction: 'Les invités peuvent interagir avec le système uniquement via le',
    guests_license: 'Ils ne nécessitent pas de licence.',
    guests_users_tab_title: 'Invités',
    import_title: 'Importer',
    inactive: 'Inactif',
    lastActivityDate_title: 'Dernière visite',
    licensing_limits_warning: 'Vous ne pouvez pas permettre à cet utilisateur de se connecter, car votre licence ne permet pas d\'ajouter d\'autres utilisateurs pouvant se connecter.',
    name_column_title: 'Nom',
    no_sercurity_logs: 'Cet utilisateur n\'a pas encore de saisies',
    password_changed: 'Le mot de passe a été modifié.',
    personal_schedule_title: 'Horaire personnel',
    regular_users_tab_title: 'Normal',
    reload: 'Actualiser',
    reset: 'Assigner',
    reset_password_confirmation: 'En cliquant sur « Générer », un nouveau mot de passe sera généré et envoyé par e-mail à l\'utilisateur.',
    reset_password_done: 'Un nouveau mot de passe a été généré et envoyé.',
    reset_password_menu_title: 'Générer et envoyer un mot de passe',
    reset_password_title: 'Voulez-vous vraiment générer et envoyer par e-mail le nouveau mot de passe ?',
    reset_permissions_confirmation: 'Pour appliquer le rôle actuel de l\'utilisateur ({0}) à tous les projets dont l\'utilisateur est membre, cliquez sur Assigner. L\'opération ne peut pas être annulée. Pour abandonner, cliquez sur Annuler.',
    reset_permissions_done: 'Le rôle actuel a été assigné.',
    reset_permissions_menu: 'Assigner le rôle actuel',
    reset_permissions_title: 'Souhaitez-vous vraiment assigner le rôle actuel à tous les projets de l\'utilisateur ?',
    security_logs_action: 'Action',
    security_logs_date: 'Date',
    security_logs_modal_title: 'Journal de sécurité pour',
    security_logs_title: 'Journal de sécurité',
    securitylog_msg_GuestConverted: 'Le rôle a été modifié de Invité à {0} par {1}.',
    securitylog_msg_LoginChanged: 'L\'identifiant a été par l\'utilisateur {0}.',
    securitylog_msg_LoginChangedBySelf: 'L\'identifiant a été changé.',
    securitylog_msg_PasswordChanged: 'Le mot de passe a été changé par l\'utilisateur {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'Le mot de passe a été récupéré.',
    securitylog_msg_PasswordChangedBySelf: 'Le mot de passe a été changé.',
    securitylog_msg_PasswordGenerated: 'Le mot de passe a été généré par l\'utilisateur {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'Le mot de passe a été généré.',
    securitylog_msg_PasswordIncorrect: 'Mot de passe incorrect.',
    securitylog_msg_RecoveryRequest: 'Demande de récupération.',
    securitylog_msg_RoleChanged: 'Le rôle a été modifié de {0} à {1} par {2}.',
    securitylog_msg_UserLockout: 'L\'utilisateur a été verrouillé après des tentatives de mots de passe infructueuses.',
    securitylog_msg_UserLockoutDueToInactivity: 'L\'utilisateur a été verrouillé en raison de l\'inactivité',
    securitylog_msg_UserUnlocked: 'L\'utilisateur a été déverrouillé par l\'utilisateur {0}.',
    selected_users: '1#{0} Utilisateur sélectionné#{0} Utilisateurs sélectionnés',
    Set_teams: 'Équipes',
    show: 'Afficher',
    show_other_reasons: 'Afficher les autres raisons',
    skills: 'Compétences',
    skills_updated_successfully: 'Les compétences ont été mises à jour avec succès',
    skillsDeleteConfirm: 'La compétence sera supprimée de toutes les compétences de l\'utilisateur',
    suggest_deactivate: 'Vous pouvez masquer l\'utilisateur n\'importe où dans le {brandName} (sauf sur la page Utilisateurs et dans l\'historique des affectations de projet et de tâche) en changeant son statut sur Inactif. De cette façon, vous pouvez libérer une licence pour un autre utilisateur.',
    teams: 'Équipes',
    teams_updated_successfully: 'Les équipes ont été mises à jour avec succès',
    teamsDeleteConfirm: 'L\'équipe sera supprimée des équipes de chaque utilisateur',
    TimerText: '1#{0} seconde#{0} secondes',
    unlock: 'Déverrouiller',
    user_conversion_done: '{0} a été converti avec succès.',
    user_conversion_title: 'Conversion d\'utilisateur',
    user_duplicate_email_error: 'Un utilisateur avec l\'e-mail spécifié existe déjà',
    user_duplicate_login_error: 'Un utilisateur avec le nom d\'utilisation spécifié existe déjà',
    user_licensing_limits_warning: 'Vous ne pouvez pas activer la Connexion possible pour cet utilisateur, car il n\'y a plus de licences disponibles.',
    User_NotFound_Title: 'Utilisateur demandé introuvable',
    userRates: 'Historique des taux',
    userRates_date: 'Date de la modification',
    userRates_hourlyRate: 'Taux de facturation',
    userRates_hourlyRateInternal: 'Taux interne',
    userRates_title: 'Historique des taux pour {0}',
};
